module.exports = __webpack_public_path__ + "img/banner.40e8f3d3.jpg";